import React from 'react'
import { createContextHoc } from 'legacy/contexts/utils'

export enum Flipper {
  RxTlogs = 'rx_tlogs',
  CatalogMetricsV2 = 'catalog_metrics_v2',
  RxPerformanceMetrics = 'rx_performance_metrics',
  InventoryFileState = 'inventory_file_state',
  DepartmentOrdering = 'department_ordering',
  AisleOrdering = 'aisle_ordering',
  AlcoholOrderTooltip = 'alcohol_order_tooltip',
  OrderColumnDeliveryOption = 'order_column_delivery_option',
  StoreGroups = 'store_groups',
  HasImageFilter = 'has_image_filter',
  TopProducts = 'top_products',
  ModernFilesSection = 'modern_files_section',
  ConnectConfiguration = 'connect_configuration',
  Merchandising = 'rt_merchandising',
  PromotedPlacements = 'rt_promoted_placements',
  PromotedPlacementsExternalUrl = 'promoted_placements_external_url',
  HomeAnnouncementBanners = 'home_announcement_banners',
  InternalAdminPanel = 'internal_admin_panel',
  HideDefaultDepartments = 'hide_default_departments',
  DisplayProductCategoryPathInProductDetails = 'display_product_category_path_in_product_details',
  ProductRequestHideDepartmentAisle = 'product_request_hide_department_aisle',
  CatalogSearchHideDepartmentAisle = 'catalog_search_hide_department_aisle',
  MeshGetStorefrontPlacements = 'mesh_get_storefront_placements',
  EnterpriseI18nHeroBanners = 'enterprise_i18n_hero_banners',
  CatalogHideProductAisles = 'catalog_hide_product_aisles',
  RetailerAccountManagementV2 = 'retailer_account_management_v2',
  StoreOperationNavigation = 'dashboard_store_ops_nav',
  ordersOperationalDashboard = 'rt_orders_operational_dashboard',
  PartnerOnboardingSignupInProgressRedirect = 'partner_onboarding_signup_in_progress_redirect',
  WebhookConfiguration = 'rt_webhook_configuration',
  NavShowAccessControls = 'rt_ipp_nav_show_access_controls',
  ScanAndPay = 'rt_scan_and_pay_retailers',
  AuditLogs = 'rt_audit_logs_list',
  RetailerCollections = 'rt_retailer_collections',
  FeatureEducation = 'rt_feature_education',
  // hygen:inject flipper
}

export type Flips = { [key in Flipper]?: boolean }

export interface FlipperContextValue {
  flipperLoading: boolean
  flipper: Flips
}

export const FlipperContext = React.createContext<FlipperContextValue | null>(null)

FlipperContext.displayName = 'FlipperContext'

export const withFlipperContext = createContextHoc(FlipperContext, {
  displayName: 'withFlipperContext',
  required: true,
})
